module.exports = __webpack_public_path__ + "static/media/04.26ea9dc8.png";